
                  export default function (Component) {
                      Component.__source = "src/views/Main.vue"
                  }
              